import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Text, TextButton } from 'wix-style-react';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { faqSubtitleMap } from '../../constants';
import s from './Faq.scss';
import { Language } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';

const newSupportLinkLangs = new Set([
  Language.EN,
  Language.ES,
  Language.PT,
  Language.FR,
  Language.DE,
  Language.RU,
  Language.IT,
  Language.JA,
  Language.KO,
  Language.TR,
  Language.PL,
  Language.NL,
]);
interface SubtitleProps {
  rootStore: RootStore;
}
const FaqSideSubtitleComp: React.FC<SubtitleProps> = (props: SubtitleProps) => {
  const { t } = useTranslation();
  const { theme } = usePageModeContext();
  const { locale } = props.rootStore.appStore.appContext;
  const useChatbotLink = newSupportLinkLangs.has(locale as Language);
  const contactLink = useChatbotLink
    ? 'faq_section.faq_subtitle_support_contact_new'
    : 'faq_section.faq_subtitle_support_contact';
  return (
    <div className={s.subtitle}>
      <Text weight='normal' size='medium' tagName='p'>
        {t('faq_section.faq_subtitle')}{' '}
        <span>
          <Trans i18nKey={faqSubtitleMap[theme].faqSubtitle}>
            {faqSubtitleMap[theme].faqSubtitle}
            <TextButton
              as='a'
              size='medium'
              target='_blank'
              href={t('faq_section.faq_subtitle_support_link')}
            >
              faq_section.faq_subtitle_support_link
            </TextButton>
            <TextButton
              as='a'
              size='medium'
              target='_blank'
              dataHook='contact-us'
              data-testid='contact-us'
              href={t(contactLink)}
            >
              faq_section.faq_subtitle_support_contact
            </TextButton>
          </Trans>
        </span>
      </Text>
    </div>
  );
};

export const FaqSideSubtitle = withInjectedRootStore(FaqSideSubtitleComp);
